import isEmpty from '../../utils/isEmpty';
import widgetIsPresent from '../../utils/widgetIsPresent';

export const DDC_INVENTORY_FILTERSEARCH = 'ddc.inventory.filterSearch';

function filterSearch({
	DDC: {
		dataLayer: {
			page: {
				attributes: { vehicleResultCount } = {},
				pageInfo: { isVlp, pageName, pageWidgets } = {},
				queryFacets = {}
			}
		}
	}
}) {
	let eventObject;
	const isNoResults = pageName?.indexOf('NO_RESULTS') > -1;
	const isShowroom = pageName === 'SHOWROOM';
	const isSRP = widgetIsPresent(/ws-inv-listing/, pageWidgets);

	if (
		vehicleResultCount !== null && // legacy vlp has this as null when the widget hidden
		!isSRP &&
		!isShowroom &&
		(isVlp ||
			isNoResults ||
			// When checking for the inventory listing widget, exclude the 'blank' version
			widgetIsPresent(
				/\.inventory-listing\.(?!blank|sitemap)/,
				pageWidgets
			) ||
			!isEmpty(queryFacets))
	) {
		const resultCount = isNoResults ? '0' : vehicleResultCount;
		eventObject = {
			eventType: DDC_INVENTORY_FILTERSEARCH,
			eventData: {
				resultCount,
				queryFacets
			}
		};
	}

	return eventObject;
}

export default filterSearch;
